module.exports = __webpack_public_path__ + "static/media/rampage.97583125.png";